import Analytics from 'analytics-node';

const analytics = new Analytics('8s2uRP3pht8NgX3vLJoB3nsasuk87tbf');

export const pageView = () => {
  analytics.page({
    userId: 'anonymousId',
    category: 'case-study',
    name: 'FB Case Study',
    properties: {
      title: 'FB Case Study',
    },
  });
};

export const clickTracking = (eventName) => {
  analytics.track({
    userId: 'anonymousId',
    event: eventName,
  });
};


// WEBPACK FOOTER //
// ./src/utils/analytics.js